import React from 'react';
import { useRecoilValue } from 'recoil';
import { CardBody } from '../../components/CardBody';
import { CardHeader } from '../../components/CardHeader';
import { CardTitle } from '../../components/CardTitle';

import { allProductsState } from '../../recoil/atoms';
import { assetPathFn } from '../../util';
import { ShopNowCardFooter, ShopNowCardSection } from '../HomeLander/HomeLanderMobile';
import { HeroCallout } from '../HeroCallout';
import { WistiaPanel } from '../../components/WistiaPanel';
import { NewsIcons } from '../../product_detail/components/NewsIcons';
import { ShopAllColors } from '../components/ShopAllColors';
import { ProductFeatures } from '../components/ProductFeatures';
import { LanderTopHero } from '../components/LanderTopHero';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import { CardFooter } from '../../components/CardFooter';
import styles from './BoldnessBodysuitLanderMobile.module.scss';
import { useLanderControls } from '../LanderContext';
import { ProductReviewQuote } from '../components/ProductReviewQuote';

export const BoldnessBodysuitLanderMobile: React.FC = () => {
  const allProducts = useRecoilValue(allProductsState);
  const { scrollToProductSection } = useLanderControls();

  const wistiaVideoId = 'txjj1yry1r';
  const padding = { padding: '145.0% 0 0 0' };

  return (
    <>
      <CardBody>
        <LanderTopHero
          heroImage={'mobile-boldness-bodysuit-lander-top-hero-1.jpg'}
          title={'Boldness Bodysuit'}
          subTitle={'The world’s most powerful sculpting bodysuit.'}
        >
          <HeroCallout
            orderIndex={0}
            label={
              <>
                Underwire-free
                <br /> lift
              </>
            }
            titleStyles={{ lineHeight: '22px', textAlign: 'right' }}
            inlineStyles={{
              mobile: {
                right: `22%`,
                top: `48%`,
                flexDirection: 'row',
              },
            }}
          />
          <HeroCallout
            orderIndex={1}
            label={
              <>
                Serious waist
                <br /> countouring
              </>
            }
            titleStyles={{ lineHeight: '22px' }}
            inlineStyles={{
              mobile: {
                left: `34%`,
                top: `61%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={3}
            titleStyles={{ lineHeight: '22px' }}
            label={
              <>
                Bonded
                <br /> compression
              </>
            }
            inlineStyles={{
              mobile: {
                left: `55.5%`,
                top: `71%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={3}
            titleStyles={{ lineHeight: '22px', marginTop: 10, textAlign: 'center' }}
            label={
              <>
                Supportive
                <br /> boning
              </>
            }
            inlineStyles={{
              mobile: {
                left: `29%`,
                top: `76%`,
                flexDirection: 'column-reverse',
              },
            }}
          />
        </LanderTopHero>
      </CardBody>
      <ShopNowCardFooter onClick={scrollToProductSection} />
      <CardHeader />
      <CardBody>
        <NewsIcons />
        <ProductFeatures
          features={[
            {
              imgName: 'feature-bb-desktop-1.jpg',
              title: 'Extreme sculpting',
              description: 'Strong, bonded panels and 360° boning provide maximum body sculpting.',
            },
            {
              imgName: 'feature-bb-desktop-2.jpg',
              title: 'Ditch your bra',
              description: 'Ultra supportive, molded bust support provides lift without underwire.',
            },
            {
              imgName: 'feature-bb-desktop-3.jpg',
              title: 'Stylish and supportive',
              description: 'Smart details and flattering features make a confidence-boosting fashion statement.',
            },
          ]}
        />
        <CardTitle text="A bodysuit that does more." style={{ paddingTop: 0 }} type="capital" />
        <div className={styles.comparison}>
          <img src={assetPathFn('boldness-bodysuit-before-after.jpg')} alt="comparison" />
          <div>
            <div>competitor</div>
            <div>
              superpower <br />
              short
            </div>
          </div>
        </div>
        <ShopNowCardSection onClick={scrollToProductSection} />
        <ProductReviewQuote
          backgroundColor="#F1F2F2"
          rightPanelMaxWidth={'720px'}
          quotes={[
            {
              quoteText: `"This suit offers such flattering support and feels incredibly comfortable. There is no adjusting or "fixing" while you wear it."`,
              author: '- Amy A.',
            },
            {
              quoteText: `"I wear this when I want really powerful shapewear but it also works as a top on it’s own, it's really like two for one for me."`,
              author: '- Tanya M.',
            },
            {
              quoteText: `"I got this to wear under dress-up clothes, but it is so comfortable and effective that I am wearing it with jeans, too. No side boob!!! Tight tummy, real curves at waist. Easy to undo for bathroom."`,
              author: '- Sherri H.',
            },
          ]}
          imgName="bb-quote-mobile-1.jpg"
        />
        <WistiaPanel videoId={wistiaVideoId} responsivePadding={padding} />
        <ShopAllColors product={allProducts[ProductHandle.BoldnessBodysuit]} />
      </CardBody>
      <CardFooter />
    </>
  );
};

export default BoldnessBodysuitLanderMobile;
